export default "__VITE_ASSET__8l2iGyqh__"